import React from "react";
import { MdEmail, MdPhone, MdPerson, MdWork } from "react-icons/md";
import { FaUserTie } from "react-icons/fa";

function ViewTeam({ details }) {
  // Helper function to get readable role name
  const getRoleName = (role) => {
    if (!role) return null;

    const roleMap = {
      event_organizer: "Event Organizer",
      co_event_organizer: "Co Organizer",
      event_org_marketing: "Marketer",
      event_org_sales: "Sales",
      host: "Event Host",
      session_coordinator: "Session Host",
      registrationOfficer: "Support Desk",
      event_support_desk: "Support Desk",
      securityGuard: "Security",
      "Event Organizer": "Event Organizer",
      "Event Host": "Event Host",
      Marketing: "Marketer",
      Sales: "Sales",
      Security: "Security",
      "Support Desk": "Support Desk",
    };

    return roleMap[role] || role;
  };

  const teamRole = details?.roles || details?.role;

  return (
    <div className="w-100 d-flex justify-content-center p-4">
      <div
        style={{
          width: "100%",
          maxWidth: 450,
          borderRadius: 20,
          backgroundColor: "#ffffff",
          boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
        }}
      >
        {/* Header Gradient Bar */}
        <div
          style={{
            height: 6,
            background: "linear-gradient(135deg, #F68A20 0%, #ff9f43 100%)",
          }}
        />

        {/* Profile Section */}
        <div className="text-center p-4" style={{ backgroundColor: "#fafafa" }}>
          {/* Avatar Circle with Gradient Border */}
          <div
            style={{
              width: 100,
              height: 100,
              margin: "0 auto 16px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #F68A20 0%, #ff9f43 100%)",
              padding: 4,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                backgroundColor: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <MdPerson size={48} color="#F68A20" />
            </div>
          </div>

          {/* Name */}
          <h2
            style={{
              fontSize: 24,
              fontWeight: 700,
              color: "#1a1a1a",
              margin: 0,
              letterSpacing: "-0.5px",
            }}
          >
            {details?.firstName} {details?.lastName}
          </h2>

          {/* Role Badge */}
          {teamRole && (
            <div
              style={{
                display: "inline-block",
                marginTop: 12,
                padding: "6px 20px",
                backgroundColor: "rgba(246, 138, 32, 0.1)",
                borderRadius: 20,
                border: "1px solid rgba(246, 138, 32, 0.2)",
              }}
            >
              <span
                style={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#F68A20",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                {getRoleName(teamRole)}
              </span>
            </div>
          )}

          {/* Title */}
          {details?.title && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 6,
                marginTop: 12,
                color: "#6b7280",
                fontSize: 14,
              }}
            >
              <FaUserTie size={14} />
              <span style={{ fontWeight: 500 }}>{details.title}</span>
            </div>
          )}
        </div>

        {/* Details Section */}
        <div className="p-4">
          <div
            style={{
              fontSize: 12,
              fontWeight: 700,
              color: "#9ca3af",
              textTransform: "uppercase",
              letterSpacing: "1px",
              marginBottom: 20,
            }}
          >
            Contact Information
          </div>

          {/* Email */}
          {details?.email && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "14px 16px",
                backgroundColor: "#f9fafb",
                borderRadius: 12,
                marginBottom: 12,
                transition: "all 0.2s ease",
                border: "1px solid #f3f4f6",
              }}
            >
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 10,
                  backgroundColor: "rgba(246, 138, 32, 0.1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: 14,
                }}
              >
                <MdEmail size={20} color="#F68A20" />
              </div>
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: 11,
                    color: "#9ca3af",
                    fontWeight: 500,
                    marginBottom: 2,
                  }}
                >
                  Email
                </div>
                <div
                  style={{
                    fontSize: 14,
                    color: "#1f2937",
                    fontWeight: 500,
                    wordBreak: "break-all",
                  }}
                >
                  {details.email}
                </div>
              </div>
            </div>
          )}

          {/* Phone */}
          {details?.phoneNumber && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "14px 16px",
                backgroundColor: "#f9fafb",
                borderRadius: 12,
                transition: "all 0.2s ease",
                border: "1px solid #f3f4f6",
              }}
            >
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 10,
                  backgroundColor: "rgba(246, 138, 32, 0.1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: 14,
                }}
              >
                <MdPhone size={20} color="#F68A20" />
              </div>
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: 11,
                    color: "#9ca3af",
                    fontWeight: 500,
                    marginBottom: 2,
                  }}
                >
                  Phone
                </div>
                <div
                  style={{
                    fontSize: 14,
                    color: "#1f2937",
                    fontWeight: 500,
                  }}
                >
                  {details.phoneNumber}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Footer Accent */}
        <div
          style={{
            height: 4,
            backgroundColor: "#f3f4f6",
          }}
        />
      </div>
    </div>
  );
}

export default ViewTeam;